import { useCallback, useEffect, useState } from 'react';
import { MetaGamesService } from '../services';
import { MetaGameType } from '../state/metaGames.types';
import { logError } from '@bonanza-social/toolkit/logging';

const useMetaGameLaunchUrl = (gameType: MetaGameType) => {
  const [launchUrl, setLaunchUrl] = useState<string>();

  const fetchLaunchUrl = useCallback(async () => {
    try {
      const { url } = await MetaGamesService.getLaunchUrl({
        data: { prizeDelivery: gameType },
      });

      setLaunchUrl(url);
    } catch (error) {
      logError(`Meta game launch url request failure. (${gameType})`, error);
    }
  }, [gameType]);

  useEffect(() => {
    if (!launchUrl) {
      fetchLaunchUrl();
    }
  }, [launchUrl, fetchLaunchUrl]);

  return launchUrl;
};

export default useMetaGameLaunchUrl;
